import { render, staticRenderFns } from "./NModel.vue?vue&type=template&id=0c0af9ec&scoped=true"
import script from "./NModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./NModel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NModel.vue?vue&type=style&index=0&id=0c0af9ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0af9ec",
  null
  
)

export default component.exports